/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { AppProps } from 'next/app'
import Script from 'next/script'
import prettyBytes from 'pretty-bytes'
import { useState } from 'react'
import { HydratingRoot } from 'react-hydrated'
import { Dump } from '../libs/dump'
import { CookieProvider } from '../src/components/shared/CookieProvider'
import { ScrollLock } from '../src/components/shared/ScrollLock'
import { TranslationRoot } from '../src/contexts/TranslationContext'
import type { SemanticKeyResult } from '../src/data/SemanticKeyFragment'
import '../src/styles/globals.sass'
import { useActiveDog } from '../src/user/ActiveDogContext'
import { AuthContextProvider, useAuth } from '../src/user/UserContext'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
			refetchInterval: false,
			refetchIntervalInBackground: false,
			staleTime: 1000 * 60 * 60 * 24,
			gcTime: 1000 * 60 * 60 * 24,
		},
	},
})

function MyApp({ Component, pageProps }: AppProps) {
	console.log('Props size:', prettyBytes(JSON.stringify(pageProps).length))
	const semanticKeys = ((pageProps as any)?.data?.semantic?.listSemanticKey ?? []) as SemanticKeyResult[]

	return (
		<CookieProvider>
			<Script id="google-analytics" strategy="lazyOnload">
				{`
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}', {
					page_path: window.location.pathname,
					});
				`}
			</Script>
			<HydratingRoot>
				<QueryClientProvider client={queryClient}>
					<ReactQueryDevtools initialIsOpen={false} />
					<TranslationRoot semanticKeys={semanticKeys}>
						<ScrollLock>
							<AuthContextProvider>
								<Component {...pageProps} />
								{process.env.NODE_ENV === 'development' && <DogInfo />}
							</AuthContextProvider>
						</ScrollLock>
					</TranslationRoot>
				</QueryClientProvider>
			</HydratingRoot>
		</CookieProvider>
	)
}
export default MyApp

function DogInfo() {
	const [open, setOpen] = useState(false)
	const auth = useAuth()
	const dog = useActiveDog()

	return (
		<div
			onClick={() => {
				setOpen((o) => !o)
			}}
			style={{
				position: 'fixed',
				zIndex: 100,
				left: 10,
				bottom: 10,
				maxWidth: '50vw',
				minWidth: 20,
				minHeight: 20,
				background: '#000',
				overflow: 'hidden',
				borderRadius: '.75em',
			}}
		>
			{open && (
				<Dump
					data={{
						auth,
						dog,
					}}
				/>
			)}
		</div>
	)
}
